import { hasOwn } from './utils';

/**
 * Overrides the default inventory config sort to ['geodist asc'], if the following conditions are met:
 * 1. `geoZip` URL parameter is present.
 * 2. `sortBy` URL parameter is NOT present.
 * 3. The `disableGeodistSort` preference is `false`.
 *
 * Note: The `geoZip` parameter is added only if the `geoLocationEnabled` preference is set to true
 * or if it's explicitly provided by the user as a URL parameter.
 *
 * @param {Object} requestBody - The request body object containing inventory parameters and preferences.
 * @param {Object} requestBody.inventoryParameters - The inventory parameters object containing URL parameters.
 * @param {Object} requestBody.preferences - The preferences object.
 * @returns {string} - The updated request body as a JSON string with the modified `sortBy` parameter .
 */

export const applyDefaultSortBy = (requestBody) => {
	const { inventoryParameters = {}, preferences } = requestBody;

	const hasGeoZipUrlParam = hasOwn(inventoryParameters, 'geoZip');
	const hasSortByUrlParam = !!inventoryParameters.sortBy?.[0];
	const isGeodistSortDisabled = preferences?.disableGeodistSort === 'true';

	if (hasGeoZipUrlParam && !hasSortByUrlParam && !isGeodistSortDisabled) {
		return JSON.stringify({
			...requestBody,
			inventoryParameters: {
				...inventoryParameters,
				sortBy: ['geodist asc']
			}
		});
	} else {
		// return the default sort defined in inventory config
		return JSON.stringify(requestBody);
	}
};
